"use client"

import { FC } from "react"
import { useNavigationStore } from "@/store/navigation"

import { Icons } from "./Icons"

const menuItems = [
  {
    name: "คลังบทเรียนทั้งหมด",
    href: "/public-games",
    icon: Icons.Search,
  },
  {
    name: "สร้างแบบฝึกหัดใหม่",
    href: "/create-game",
    icon: Icons.MagicPen,
  },
  {
    name: "คู่มือการใช้งาน",
    href: "/player-coupons",
    icon: Icons.ClosedBook,
  },
]

const Sidebar: FC = () => {
  const { activePage, setActivePage } = useNavigationStore()

  const isActive = (href: string) => activePage === href

  return (
    <aside
      className="fixed left-0 z-10 h-full w-[13%] bg-white shadow"
      style={{ overflowX: "hidden", overflowY: "auto" }}
    >
      <div className="flex flex-col gap-8 pl-1.5 pt-[92px]">
        {menuItems.map((item) => {
          const active = isActive(item.href)
          const IconComponent = item.icon
          const color = active ? "#0092D7" : "#4e4e4e"

          return (
            <button
              key={item.href}
              type="button"
              onClick={() => setActivePage(item.href)}
              className={`flex w-full items-center gap-4 rounded-sm px-4 py-0 text-left transition ${active
                ? "text-[#0092D7]"
                : "text-[#4e4e4e] hover:opacity-75"
                }`}
            >
              <div style={{ color }}>
                <IconComponent />
              </div>
              <span className={active ? "text-[#0092D7]" : "text-[#4e4e4e]"}>
                {item.name}
              </span>
            </button>
          )
        })}
      </div>
    </aside>
  )
}

export default Sidebar
